export default "__VITE_ASSET__C4zK9SPG__"